import React, { useState, useEffect } from "react"
import { Modal } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import SweetAlert from "react-bootstrap-sweetalert"
import { getCurrentUser, getPermission } from "../../helpers/Utils"
import { Link } from "react-router-dom"
import axios from "axios"
import LongText from "../MessageField"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

let selectedRoleId = []

const LedgerList = props => {
  const [ledger, setLedger] = useState(props.data)
  const [modal_standard, setmodal_standard] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [editModal, setEditModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const canEditAmount =
    getCurrentUser()?.role_name === "Administrator" ||
    getPermission()?.ledger?.ledger?.edit?.is_checked === "yes"

  const deleteLedger = e => {
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/ledger/${e}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLedger("")
          setdynamic_description(res.data.message)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  const editAmount = (e, value) => {
    setLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/ledger/${ledger.id}`,
        {
          amount: value.amount,
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setLoading(false)
        if (res.data.status) {
          setLedger({
            ...ledger,
            amount: res.data.data?.amount ?? value.amount,
          })
          setEditModal(false)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    selectedRoleId = []
  }, [])

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        setEditModal(false)
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  const getSelectedId = (e, check) => {
    if (check.target.checked) {
      selectedRoleId.push(e)
      const uniqueID = selectedRoleId.filter((val, id, array) => {
        return array.indexOf(val) == id
      })
      selectedRoleId = uniqueID
      props.setLeadsSelectedIds(selectedRoleId)
    } else {
      selectedRoleId = props.leadsSelectedIds
      var array = selectedRoleId
      var index = array.indexOf(e)
      if (index !== -1) {
        array.splice(index, 1)
      }
      props.setLeadsSelectedIds(selectedRoleId)
    }
    if (selectedRoleId.length == 0) {
      props.setBlur(false)
    } else {
      props.setBlur(true)
    }
  }

  if (ledger === "") {
    return ""
  } else
    return (
      <>
        <tr key={props.i}>
          <td>
            <input
              onChange={e => getSelectedId(ledger.id, e)}
              name="chk"
              value={ledger.id}
              className="p-0 d-inline-block"
              type="checkbox"
            />
          </td>
          <td>{props.counter + props.i}</td>
          <td>{ledger.id}</td>
          <td>
            {ledger?.firm_name == null || ledger?.firm_name == "" ? (
              ""
            ) : (
              <span className="">({ledger?.firm_name})</span>
            )}
            <br />
            <Link
              to={`/customers?id=${ledger.customer_id}`}
              className="text-info"
            >
              {ledger.customer_name}
            </Link>
          </td>
          <td>{ledger.order_id}</td>
          <td>
            {ledger.is_first_order == 1 ? (
              <span className="badge bg-success">New</span>
            ) : (
              <span className="badge bg-warning text-dark">Repeat</span>
            )}
          </td>
          <td>&#8377; {ledger.amount}</td>
          <td>
            <LongText content={ledger.message} />
          </td>
          {getCurrentUser()?.enable_branch == 1 ? (
            <td>{ledger.branch?.name}</td>
          ) : (
            ""
          )}
          <td>
            {ledger.type == "paid" ? (
              <span className="badge bg-success">Credit</span>
            ) : null}
            {ledger.type == "outstanding" ? (
              <span className="badge bg-danger">Debit</span>
            ) : null}
          </td>
          <td>{ledger.user_name}</td>
          <td>{ledger.transaction_date}</td>
          <td>
            {canEditAmount ? (
            <a
              className="text-primary ms-2"
              onClick={() => {
                setEditModal(true)
              }}
              style={{ cursor: "pointer" }}
            >
              <i className="fas fa-edit" />
            </a>
          ) : (
            ""
          )}
            {getPermission().ledger.ledger.delete.is_checked === "yes" ? (
              <a
                className="text-danger ms-2"
                onClick={() => {
                  setconfirm_alert(true)
                }}
              >
                <i className="fas fa-trash-alt" />
              </a>
            ) : (
              ""
            )}
            {confirm_alert ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmButtonText="Yes, delete it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setconfirm_alert(false)
                  setsuccess_dlg(true)
                  deleteLedger(ledger.id)
                  setdynamic_title("Deleted")
                  setdynamic_description("Your file has been deleted.")
                }}
                onCancel={() => setconfirm_alert(false)}
              >
                You won't be able to revert this!
              </SweetAlert>
            ) : null}
          </td>
        </tr>
        {editModal ? (
          <Modal isOpen={editModal} centered={true}>
            <AvForm
              className="modal-title mt-0"
              onValidSubmit={(e, v) => {
                editAmount(e, v)
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0">Edit Amount</h5>
                <button
                  type="button"
                  className="cross__btn"
                  onClick={() => setEditModal(false)}
                  aria-hidden="true"
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <p className="mb-2">
                  Ledger ID: {ledger.id}
                  {ledger.order_id ? ` | Order ID: ${ledger.order_id}` : ""}
                </p>
                <div className="mb-3 required">
                  <AvField
                    label="Amount"
                    type="number"
                    name="amount"
                    min="1"
                    placeholder="Enter Amount"
                    defaultValue={ledger.amount}
                    onFocus={e =>
                      e.target.addEventListener(
                        "wheel",
                        function (event) {
                          event.preventDefault()
                        },
                        { passive: false }
                      )
                    }
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Amount is required",
                      },
                      min: {
                        value: 1,
                        errorMessage: "Amount must be at least 1",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                {loading ? (
                  <button className="btn btn-primary" type="button" disabled>
                    Loading
                  </button>
                ) : (
                  <button className="btn btn-primary" type="submit">
                    Update
                  </button>
                )}
              </div>
            </AvForm>
          </Modal>
        ) : null}
      </>
    )
}
export default LedgerList
